import * as Sentry from "@sentry/browser";
import { getCurrentUser } from "aws-amplify/auth";

const isProd = process.env.NODE_ENV === "production";

class LoggerService {
  async initializeUserContext() {
    try {
      const userLogged = await getCurrentUser();

      if (userLogged?.username) {
        Sentry.setUser({ id: userLogged.username });
        if (!isProd) console.log("Sentry user set:", userLogged?.username);
      }
    } catch (error) {
      this.error(error, {
        transaction: "[LOGGER] - Erro ao obter usuário para o Sentry",
        tags: { flow: "set-user-sentry" },
      });
    }
  }

  warn(message: string, extra?: Record<string, any>) {
    if (!isProd) console.warn(message, extra);
    Sentry.addBreadcrumb({ message, level: "warning", data: extra });
  }

  error(
    error: unknown,
    options?: {
      transaction?: string;
      tags?: Record<string, string>;
      context?: Record<string, any>;
    }
  ) {
    const { transaction, tags, context } = options || {};

    Sentry.withScope((scope) => {
      if (transaction) scope.setTransactionName(transaction);
      if (tags)
        Object.entries(tags).forEach(([key, value]) =>
          scope.setTag(key, value)
        );
      if (context) scope.setContext("context", context);
      scope.setLevel("error");
      Sentry.captureException(error);
    });

    if (!isProd) console.error("[LoggerService]", error, options);
  }

  fatal(
    error: unknown,
    options?: {
      transaction?: string;
      tags?: Record<string, string>;
      context?: Record<string, any>;
    }
  ) {
    const { transaction, tags, context } = options || {};

    Sentry.withScope((scope) => {
      if (transaction) scope.setTransactionName(transaction);
      if (tags)
        Object.entries(tags).forEach(([key, value]) =>
          scope.setTag(key, value)
        );
      if (context) scope.setContext("context", context);
      scope.setLevel("fatal");
      Sentry.captureException(error);
    });

    if (!isProd) console.error("[LoggerService]", error, options);
  }

  message(
    message: string,
    options?: {
      transaction?: string;
      tags?: Record<string, string>;
      context?: Record<string, any>;
      category?: string; // breadcrumb category
    }
  ) {
    const { transaction, tags, context, category } = options || {};

    Sentry.addBreadcrumb({
      message,
      level: "info",
      category: category ?? "log",
    });

    Sentry.withScope((scope) => {
      if (transaction) scope.setTransactionName(transaction);
      if (tags)
        Object.entries(tags).forEach(([key, value]) =>
          scope.setTag(key, value)
        );
      if (context) scope.setContext("context", context);
      scope.setLevel("info");
      Sentry.captureMessage(message);
    });

    if (!isProd) {
      console.log(`[Message - info]`, message, { transaction, tags, context });
    }
  }
}
const logger = new LoggerService();

export default logger;
